import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import BookingModule from "@/store/modules/booking";
import { computed, defineComponent, ref, watch, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import NotificationService from "@/services/notification.service";
import { LogLevel, LogService } from "@/services/logging";
import editPen from "@/assets/images/svg/edit-pen-rectangle.svg";
import roundCheckIcon from "@/assets/images/svg/green-round-check.svg";
import { Currencies } from "@/constants/currency";
import { AccountingState, PaymentMethods, PromocodeCampaignType } from "@/types/db/accounting";
import { sumArray } from "@/utils/helpers/common";
import ScannerModule from "@/store/modules/scanner";
import { extractCodeFromUrl, getPromocodeInputPlaceholder, getPromocodePaymentType, processPromocode, removeCodePayment } from "@/utils/vue-helpers/promocode";
import { getSumOfCodeGeneratedAccountingsValues } from "@/utils/vue-helpers/new-accountings";
import { getPssVoucherByToken } from "@/api/gql/product-slot-state";
import { getUntypedBookingByUuid, isBookingInDexie } from "@/utils/helpers/booking";
export default defineComponent({
  name: "Promocode",
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var editPenIconStyle = "width: 30px; height: 30px";
    var editPenIconContent = editPen;
    var editPenIconAlt = "Edit";
    var roundCheckIconStyle = "width: 32px; height: 32px; margin-right: 10px";
    var roundCheckIconContent = roundCheckIcon;
    var roundCheckIconAlt = "Check";
    var isEditOrder = ref(false);
    var promocode = ref(getExistingPromocode()
    /*BookingModule.appliedPromocode*/
    );
    var isLoading = ref(false);
    var displaySuccessMsg = computed(function () {
      // We return true if the code is applied successfully
      // the code is applied successfully if it has generated accountings
      if (getSumOfCodeGeneratedAccountingsValues(promocode.value) > 0) {
        return true;
      } else {
        return false;
      }
    });
    var isPromocodeApplied = computed(function () {
      return BookingModule.isPromocodeApplied;
    });
    var isPromocodeLengthValid = computed(function () {
      return promocode.value.length >= 5;
    });
    var appliedCodesStats = ref([]); // updates appliedCodesStats

    watchEffect( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var stats, booking, codePendingAccountings;
      return regeneratorRuntime.wrap(function _callee2$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              stats = [];
              booking = BookingModule.selectedBooking;
              codePendingAccountings = booking.accountings.filter(function (acc) {
                return acc.state === AccountingState.Pending && !acc.refund && !acc.id
                /*not coming from backend*/
                && (acc.promocode || acc.promoCodeUuid || acc.promoCodeId);
              });

              if (!(codePendingAccountings && codePendingAccountings.length)) {
                _context3.next = 5;
                break;
              }

              return _context3.delegateYield( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var codes, _loop, i;

                return regeneratorRuntime.wrap(function _callee$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        codes = _toConsumableArray(new Set(codePendingAccountings.map(function (acc) {
                          return acc.promocode || acc.promoCodeUuid;
                        }))); // console.log("applied codes");
                        // console.log(codes);

                        _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop(i) {
                          var accEntriesValues, sum, promocodeRemainingValue, promocodeOldDiscountValues, remain;
                          return regeneratorRuntime.wrap(function _loop$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  accEntriesValues = codePendingAccountings.filter(function (acc) {
                                    return acc.promocode === codes[i] || acc.promoCodeUuid === codes[i];
                                  }).map(function (acc) {
                                    return acc.accountingEntriesList;
                                  }).flat().map(function (ae) {
                                    return ae.value;
                                  });
                                  sum = sumArray(accEntriesValues); // TODO POS: Rewrite this

                                  _context.next = 4;
                                  return getPromocodeRemainingValue(String(codes[i]));

                                case 4:
                                  promocodeRemainingValue = _context.sent;
                                  _context.next = 7;
                                  return getPromocodeOldDiscountValues();

                                case 7:
                                  promocodeOldDiscountValues = _context.sent;
                                  remain = promocodeRemainingValue + promocodeOldDiscountValues;
                                  stats.push({
                                    code: String(codes[i]),
                                    ttlDiscountOrPayment: sum,
                                    remaining: remain
                                  });

                                case 10:
                                case "end":
                                  return _context.stop();
                              }
                            }
                          }, _loop);
                        });
                        i = 0;

                      case 3:
                        if (!(i < codes.length)) {
                          _context2.next = 8;
                          break;
                        }

                        return _context2.delegateYield(_loop(i), "t0", 5);

                      case 5:
                        i++;
                        _context2.next = 3;
                        break;

                      case 8:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee);
              })(), "t0", 5);

            case 5:
              appliedCodesStats.value = stats;

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee2);
    })));
    var currency = computed(function () {
      var _BookingModule$select;

      return ((_BookingModule$select = BookingModule.selectedBooking) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.currency) || Currencies.CHF;
    });
    var newLogicCodeResult = computed(function () {
      var _BookingModule$select2;

      // Here we return the pending accountings values related to this applied code that were recently created when user applied the code
      var createdAccountings = (_BookingModule$select2 = BookingModule.selectedBooking) === null || _BookingModule$select2 === void 0 ? void 0 : _BookingModule$select2.accountings.filter(function (acc) {
        return acc.state === AccountingState.Pending && !acc.refund && (acc.promocode === promocode.value || acc.promoCodeUuid === promocode.value);
      });

      if (createdAccountings && createdAccountings.length) {
        return sumArray(createdAccountings.map(function (acc) {
          return acc.accountingEntriesList;
        }).flat().map(function (ae) {
          return ae.value;
        }));
      }

      return 0; // const appliedCode = BookingModule.appliedPromocodes.find((code) => code.promocode.code === promocode.value);
      // if (!appliedCode) return 0;
      // return sumArray(getPromocodePaymentValue(BookingModule.selectedBooking?.pssList || [], appliedCode).map((it) => it.promocodeDiscountValue));
    });
    var newLogicCodeResultText = computed(function () {
      return currency.value + " " + (newLogicCodeResult.value / 100).toFixed(2);
    });

    function getPromocodeRemainingValue(_x) {
      return _getPromocodeRemainingValue.apply(this, arguments);
    }

    function _getPromocodeRemainingValue() {
      _getPromocodeRemainingValue = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(code) {
        var _BookingModule$select4;

        var dt1, appCode, currentPromocode, flatValue, pendingValue, codeResult, codeAccountings, _yield$getUntypedBook, syncedBooking, oldCodeAccountingsUuid, _BookingModule$select5, oldCodeAccountings, amountAvailable;

        return regeneratorRuntime.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                dt1 = new Date();
                appCode = promocode.value;

                if (code) {
                  appCode = code;
                }

                if (promocode.value) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt("return", 0);

              case 5:
                currentPromocode = BookingModule.appliedPromocodes.find(function (p) {
                  return p.promocode.code === appCode;
                });

                if (currentPromocode) {
                  _context6.next = 8;
                  break;
                }

                return _context6.abrupt("return", 0);

              case 8:
                flatValue = 0;
                pendingValue = 0;

                if (currentPromocode) {
                  flatValue = currentPromocode.promocode.flatValue;
                  pendingValue = Number(currentPromocode.promocode.pendingValue);
                }

                codeResult = 0; // Payment code result is the sum of accEntries recently generated by this code

                codeAccountings = (_BookingModule$select4 = BookingModule.selectedBooking) === null || _BookingModule$select4 === void 0 ? void 0 : _BookingModule$select4.accountings.filter(function (acc) {
                  return (acc.promocode === appCode || acc.promoCodeUuid === appCode) && !acc.refund;
                });

                if (!(codeAccountings && codeAccountings.length)) {
                  _context6.next = 30;
                  break;
                }

                _context6.next = 16;
                return getUntypedBookingByUuid(BookingModule.selectedBookingUUID);

              case 16:
                _context6.t1 = _yield$getUntypedBook = _context6.sent;
                _context6.t0 = _context6.t1 === null;

                if (_context6.t0) {
                  _context6.next = 20;
                  break;
                }

                _context6.t0 = _yield$getUntypedBook === void 0;

              case 20:
                if (!_context6.t0) {
                  _context6.next = 24;
                  break;
                }

                _context6.t2 = void 0;
                _context6.next = 25;
                break;

              case 24:
                _context6.t2 = _yield$getUntypedBook.booking;

              case 25:
                syncedBooking = _context6.t2;
                oldCodeAccountingsUuid = [];

                if (syncedBooking) {
                  // So we're in an Edit order
                  // lets get old accountings generated by this code
                  oldCodeAccountings = (_BookingModule$select5 = BookingModule.selectedBooking) === null || _BookingModule$select5 === void 0 ? void 0 : _BookingModule$select5.accountings.filter(function (acc) {
                    return acc.promocode === appCode || acc.promoCodeUuid === appCode;
                  });

                  if (oldCodeAccountings && oldCodeAccountings.length) {
                    oldCodeAccountingsUuid = oldCodeAccountings.map(function (acc) {
                      return String(acc.uuid);
                    });
                  }
                }

                if (oldCodeAccountingsUuid && oldCodeAccountingsUuid.length) {
                  // lets exclude old accountings from codeAccountings array
                  codeAccountings = codeAccountings.filter(function (acc) {
                    return !oldCodeAccountingsUuid.includes(String(acc.uuid));
                  });
                }

                codeResult = sumArray(codeAccountings.map(function (acc) {
                  return acc.accountingEntriesList;
                }).flat().map(function (ae) {
                  return ae.value;
                }));

              case 30:
                amountAvailable = flatValue - pendingValue - codeResult;
                return _context6.abrupt("return", amountAvailable);

              case 32:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee5);
      }));
      return _getPromocodeRemainingValue.apply(this, arguments);
    }

    var paymentType = ref(PaymentMethods.POS_PROMO_CODE);
    var successMessage = ref("");
    var inputPlaceholder = computed(function () {
      return getPromocodeInputPlaceholder(paymentType.value);
    });
    var appliedPromocodeType = computed(function () {
      var _BookingModule$applie;

      return (_BookingModule$applie = BookingModule.appliedPromocode) === null || _BookingModule$applie === void 0 ? void 0 : _BookingModule$applie.promocode.promoCodeType;
    });

    function updatePaymentType(type) {
      paymentType.value = type;
    }

    function setSuccessMessage(promocodeType) {
      switch (promocodeType) {
        case PromocodeCampaignType.TYPE_PROMO_CODE:
          successMessage.value = t("promocode.promo-code-applied");
          break;

        case PromocodeCampaignType.TYPE_GIFT_CARD_SOLD:
          successMessage.value = t("promocode.gift-card-applied");
          break;

        case PromocodeCampaignType.TYPE_VOUCHER_SOLD:
          successMessage.value = t("promocode.voucher-applied");
          break;

        case PromocodeCampaignType.TYPE_MEMBERSHIP_SOLD:
          successMessage.value = t("promocode.membership-applied");
      }
    }

    watchEffect( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!BookingModule.selectedBookingUUID) {
                _context4.next = 4;
                break;
              }

              _context4.next = 3;
              return isBookingInDexie(BookingModule.selectedBookingUUID);

            case 3:
              isEditOrder.value = _context4.sent;

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee3);
    })));

    if (isPromocodeApplied.value && appliedPromocodeType.value) {
      setSuccessMessage(appliedPromocodeType.value);
    }

    var scanPromocodeModal = ref(false);
    var ScannerTog = computed(function () {
      return ScannerModule.tog;
    });
    watch(ScannerTog, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var scannedValue, isUrl, code, scannedJsonCode, token, results, voucherCode;
      return regeneratorRuntime.wrap(function _callee4$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(ScannerModule.value && scanPromocodeModal.value)) {
                _context5.next = 65;
                break;
              }

              LogService.info("Promocode: scanner triggered, value = ".concat(ScannerModule.value)); // The scanned valued can be a json object, a url (old logic), or a simple token
              // Check if the voucherCode is a URL

              scannedValue = ScannerModule.value;
              isUrl = String(scannedValue).startsWith("http://") || String(scannedValue).startsWith("https://") || String(scannedValue).startsWith("http//") || String(scannedValue).startsWith("https//");
              code = "";

              if (!isUrl) {
                _context5.next = 18;
                break;
              }

              LogService.info("Promocode: scanned value is in url format");
              console.log("Promocode: scanned value is in url format"); // We keep the old logic of extracting the code from the url scanned

              code = extractCodeFromUrl(ScannerModule.value);
              LogService.info("Promocode: extracted from qrcode string code: ".concat(code));

              if (!(code && code.length >= 5)) {
                _context5.next = 16;
                break;
              }

              promocode.value = code;
              LogService.info("Promocode: going to process scanned promocode: ".concat(promocode.value));
              _context5.next = 15;
              return applyPromocode();

            case 15:
              LogService.info("Promocode: Done processing scanned promocode: ".concat(promocode.value));

            case 16:
              scanPromocodeModal.value = false;
              return _context5.abrupt("return");

            case 18:
              LogService.info("Promocode: scanned value is not in url format. Checking if it is json object."); // Check if the scanned value is actually a json object

              _context5.prev = 19;
              scannedJsonCode = JSON.parse(scannedValue);
              LogService.info("Promocode: scanned value is in json format attached.", {
                params: scannedJsonCode
              }); // Check if it's in the expected format

              if (!(scannedJsonCode && scannedJsonCode.code && scannedJsonCode.token)) {
                _context5.next = 33;
                break;
              }

              LogService.info("Promocode: scanned value is exactly in the expected format.", {
                params: scannedJsonCode
              }); // Lets proceed applying the code

              code = scannedJsonCode.code;
              promocode.value = scannedJsonCode.code;
              LogService.info("Promocode: going to process scanned promocode: ".concat(promocode.value));
              _context5.next = 29;
              return applyPromocode();

            case 29:
              LogService.info("Promocode: Done processing scanned promocode: ".concat(promocode.value));
              scanPromocodeModal.value = false;
              _context5.next = 35;
              break;

            case 33:
              LogService.info("Promocode: scanned value is not in the expected format", {
                params: scannedJsonCode
              }); // Lets notify the user that code couldn't be scanned

              NotificationService.showCustomMessage(t("promocode.could-not-scan"), "error");

            case 35:
              _context5.next = 65;
              break;

            case 37:
              _context5.prev = 37;
              _context5.t0 = _context5["catch"](19);
              // Couldn't parse the scanned value into a json object
              LogService.info("Promocode: scanned value is neither a url nor a valid json object. Checking if it's a simple token.");
              token = String(scannedValue).trim();

              if (!token) {
                _context5.next = 65;
                break;
              }

              _context5.prev = 42;
              _context5.next = 45;
              return getPssVoucherByToken(token);

            case 45:
              results = _context5.sent;

              if (!(results && results[0] && results[0].promocode)) {
                _context5.next = 57;
                break;
              }

              voucherCode = results[0].promocode.code || results[0].promocode.codeUnique || "";
              LogService.info("Promocode: successfully retrieved voucher code from token: ".concat(token, ", code: ").concat(voucherCode));
              promocode.value = voucherCode;
              LogService.info("Promocode: going to process retrieved promocode: ".concat(promocode.value));
              _context5.next = 53;
              return applyPromocode();

            case 53:
              LogService.info("Promocode: Done processing retrieved promocode: ".concat(promocode.value));
              scanPromocodeModal.value = false;
              _context5.next = 59;
              break;

            case 57:
              LogService.info("Promocode: no voucher code found for token: ".concat(token));
              NotificationService.showCustomMessage(t("promocode.could-not-scan"), "error");

            case 59:
              _context5.next = 65;
              break;

            case 61:
              _context5.prev = 61;
              _context5.t1 = _context5["catch"](42);
              LogService.info("Promocode Error: failed to retrieve voucher code from token: ".concat(token), {
                param: {
                  token: token,
                  tokenErr: _context5.t1
                }
              }, LogLevel.Error);
              NotificationService.showCustomMessage(t("promocode.could-not-scan"), "error");

            case 65:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee4, null, [[19, 37], [42, 61]]);
    })), {
      deep: true
    });
    /**
     * This function return the last used promocode if there are any
     */

    function getExistingPromocode() {
      var _BookingModule$select3;

      if (!isEditOrder.value) return ""; // if the booking has a promocode accounting, then we get the code  showing

      var accountings = ((_BookingModule$select3 = BookingModule.selectedBooking) === null || _BookingModule$select3 === void 0 ? void 0 : _BookingModule$select3.accountings) || [];
      var code = "";

      for (var i = 0; i < accountings.length; i++) {
        if ((accountings[i].promoCodeId || accountings[i].promoCodeUuid) && accountings[i].state === AccountingState.Completed && accountings[i].refund !== 1 && accountings[i].promocode) {
          code = accountings[i].promocode || "";
        }
      }

      return code;
    }
    /**
     * this function returns the promocode discount value of the original pulled booking
     */


    function getPromocodeOldDiscountValues() {
      return _getPromocodeOldDiscountValues.apply(this, arguments);
    }

    function _getPromocodeOldDiscountValues() {
      _getPromocodeOldDiscountValues = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _yield$getUntypedBook2;

        var syncedBooking, oldPromocodeAccountingEntries;
        return regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return getUntypedBookingByUuid(BookingModule.selectedBookingUUID);

              case 2:
                _context7.t1 = _yield$getUntypedBook2 = _context7.sent;
                _context7.t0 = _context7.t1 === null;

                if (_context7.t0) {
                  _context7.next = 6;
                  break;
                }

                _context7.t0 = _yield$getUntypedBook2 === void 0;

              case 6:
                if (!_context7.t0) {
                  _context7.next = 10;
                  break;
                }

                _context7.t2 = void 0;
                _context7.next = 11;
                break;

              case 10:
                _context7.t2 = _yield$getUntypedBook2.booking;

              case 11:
                syncedBooking = _context7.t2;

                if (!(!isEditOrder.value || !syncedBooking)) {
                  _context7.next = 14;
                  break;
                }

                return _context7.abrupt("return", 0);

              case 14:
                oldPromocodeAccountingEntries = syncedBooking.accountings.filter(function (acc) {
                  return acc.promoCodeId && acc.state === AccountingState.Completed && acc.refund !== 1;
                }).map(function (acc) {
                  return acc.accountingEntriesList;
                }).flat();
                return _context7.abrupt("return", sumArray(oldPromocodeAccountingEntries.map(function (ae) {
                  return ae.value;
                })));

              case 16:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6);
      }));
      return _getPromocodeOldDiscountValues.apply(this, arguments);
    }

    function applyPromocode() {
      return _applyPromocode.apply(this, arguments);
    }

    function _applyPromocode() {
      _applyPromocode = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var appliedCode, promocodePaymentType;
        return regeneratorRuntime.wrap(function _callee7$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!isLoading.value) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return");

              case 2:
                isLoading.value = true;
                _context8.next = 5;
                return processPromocode(promocode.value);

              case 5:
                // check if the promocode was applied
                appliedCode = BookingModule.appliedPromocodes.find(function (p) {
                  return p.promocode.code === promocode.value;
                });

                if (appliedCode) {
                  // the promocode was succesfully applied
                  // let's update the payment type UI
                  promocodePaymentType = getPromocodePaymentType(appliedCode.promocode.promoCodeType);

                  if (promocodePaymentType) {
                    paymentType.value = promocodePaymentType;
                  }
                }

                isLoading.value = false;

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee7);
      }));
      return _applyPromocode.apply(this, arguments);
    }

    return {
      displaySuccessMsg: displaySuccessMsg,
      isPromocodeApplied: isPromocodeApplied,
      promocode: promocode,
      isLoading: isLoading,
      editPenIconStyle: editPenIconStyle,
      editPenIconContent: editPenIconContent,
      editPenIconAlt: editPenIconAlt,
      isPromocodeLengthValid: isPromocodeLengthValid,
      roundCheckIconStyle: roundCheckIconStyle,
      roundCheckIconAlt: roundCheckIconAlt,
      roundCheckIconContent: roundCheckIconContent,
      t: t,
      paymentType: paymentType,
      successMessage: successMessage,
      updatePaymentType: updatePaymentType,
      PaymentMethods: PaymentMethods,
      appliedPromocodeType: appliedPromocodeType,
      inputPlaceholder: inputPlaceholder,
      setSuccessMessage: setSuccessMessage,
      isEditOrder: isEditOrder,
      scanPromocodeModal: scanPromocodeModal,
      newLogicCodeResultText: newLogicCodeResultText,
      appliedCodesStats: appliedCodesStats,
      currency: currency,
      applyPromocode: applyPromocode,
      removeCodePayment: removeCodePayment
    };
  },
  methods: {
    openScanPromocodeModal: function openScanPromocodeModal() {
      this.scanPromocodeModal = true;
    }
  }
});